import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { resolveDiagnosesFormPart } from '../../shared/common.utils';
import { GuardianEnteredByUserFormBean } from '../ReferralToPsychiatricHospitalForm/fields/GuardianSection';
import { ReferralToPsychiatricHospitalFormBean } from '../ReferralToPsychiatricHospitalForm/referralToPsychiatricHospitalForm.types';

const defaultPersonAddress = {
   street: null,
   flat: null,
   postcode: null,
   country: null,
   building: null,
   town: null,
};

export const getInitialValues = (
   referralToPsychiatricHospitalDraft: ReferralToPsychiatricHospitalFormBean | null,
   visitDiagnoses: VisitDiagnosis[] | undefined
): ReferralToPsychiatricHospitalFormBean => {
   const patientConsent = referralToPsychiatricHospitalDraft?.patientConsent;
   return {
      diagnoses: resolveDiagnosesFormPart(referralToPsychiatricHospitalDraft?.diagnoses, visitDiagnoses),
      unitNameAndAddress: referralToPsychiatricHospitalDraft?.unitNameAndAddress ?? null,
      statutoryRepresentative: referralToPsychiatricHospitalDraft?.statutoryRepresentative ?? null,
      statutoryRepresentativeAddress:
         referralToPsychiatricHospitalDraft?.statutoryRepresentativeAddress ?? defaultPersonAddress,
      statutoryRepresentativeEnteredByUser:
         referralToPsychiatricHospitalDraft?.statutoryRepresentativeEnteredByUser ??
         ({} as GuardianEnteredByUserFormBean),
      statutoryRepresentativeNotApplicable:
         referralToPsychiatricHospitalDraft?.statutoryRepresentativeNotApplicable ?? false,
      informationAboutPatient: referralToPsychiatricHospitalDraft?.informationAboutPatient ?? null,
      otherJustifyingInformation: referralToPsychiatricHospitalDraft?.otherJustifyingInformation ?? null,
      actualGuardian: referralToPsychiatricHospitalDraft?.actualGuardian ?? null,
      actualGuardianAddress: referralToPsychiatricHospitalDraft?.actualGuardianAddress ?? defaultPersonAddress,
      actualGuardianNotApplicable: referralToPsychiatricHospitalDraft?.actualGuardianNotApplicable ?? false,
      actualGuardianEnteredByUser:
         referralToPsychiatricHospitalDraft?.actualGuardianEnteredByUser ?? ({} as GuardianEnteredByUserFormBean),
      patientConsent:
         patientConsent === undefined || patientConsent === 'WITH_CONSENT' ? 'WITH_CONSENT' : 'WITHOUT_CONSENT',
      statutoryRepresentativeConsent:
         referralToPsychiatricHospitalDraft?.statutoryRepresentativeConsent ?? 'NOT_APPLICABLE',
   };
};
